module.exports = __webpack_public_path__ + "static/media/Expenses.ef770437.svg";